import{useMst}from'@models/RootStore';/**
 * The kinds of object a locale can be remembered for.
 *
 * `consultation` and `informationClarification` are root objects: the whole page follows their
 * locale. `consultationBlock` is not a root object at all - it is here because the two block
 * show pages (/library and /settings/blocks) have no root object to follow, so a single block
 * carries a locale of its own there.
 */export function useRootObjectLocale(type,id){const store=useMst();const key="".concat(type,":").concat(id);const locale=store.uiStore.getRootObjectLocale(key);const setLocale=l=>{store.uiStore.setRootObjectLocale(key,l);};return[locale,setLocale];}